
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M6.00002 13.0001C6.55002 12.4501 6.55002 11.5601 6.00002 11.0101V11.0001C5.45002 10.4501 4.55002 10.4501 4.00002 11.0001C3.45002 11.5501 3.45002 12.4501 4.00002 13.0001C4.55002 13.5501 5.45002 13.5501 6.00002 13.0001ZM20 11.0001C19.44 10.4401 18.55 10.4401 18 10.9901V11.0001C17.45 11.5501 17.45 12.4401 18 12.9901V13.0001C18.55 13.5501 19.44 13.5501 19.99 13.0001H20C20.55 12.4501 20.55 11.5501 20 11.0001ZM17 7.00005L12.71 2.71005C12.08 2.08005 11 2.52005 11 3.41005V9.59005L7.11002 5.70005C6.72002 5.31005 6.09002 5.31005 5.70002 5.70005C5.31002 6.09005 5.31002 6.72005 5.70002 7.11005L10.59 12.0001L5.70002 16.8901C5.31002 17.2801 5.31002 17.9101 5.70002 18.3001C6.09002 18.6901 6.72002 18.6901 7.11002 18.3001L11 14.4101V20.5901C11 21.4801 12.08 21.93 12.71 21.3001L17 17.0001C17.39 16.6101 17.39 15.9801 17 15.5801L13.41 12.0001L17 8.42005C17.39 8.03005 17.39 7.39005 17 7.00005ZM14.88 16.2901L13 18.1701V14.4101L14.88 16.2901ZM13 9.59005V5.83005L14.88 7.71005L13 9.59005Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-bluetooth-connected`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconBluetoothConnected

    ```js
    <b-new-b-icon-bluetooth-connected />
    ```
</docs>


